import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const statusFilter = ({
  expensesContext,
  initialFilterValues,
  clearQuickFilters,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.approved'),
      value: 'approved',
    },
    {
      label: i18n.t('expenses_v2.list.filters.changes_requested'),
      value: 'changes_requested',
    },
    {
      label: i18n.t('expenses_v2.list.filters.draft'),
      value: 'draft',
    },
    {
      label: i18n.t('expenses_v2.list.filters.in_payroll'),
      value: 'in_payroll',
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      value: 'paid',
    },
    {
      label: i18n.t('expenses_v2.list.filters.pending'),
      value: 'pending',
    },
    {
      label: i18n.t('expenses_v2.list.filters.rejected'),
      value: 'rejected',
    },
    {
      label: i18n.t('expenses_v2.list.filters.reversed'),
      value: 'reversed',
    },
    {
      label: i18n.t('expenses_v2.list.filters.sent_to_pay'),
      value: 'sent_to_pay',
    },
  ]

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: initialFilterValues.status ? [initialFilterValues.status] : [],
      },
    ],
    onUpdateValue: (param) => {
      trackFilters('status', expensesContext)
      if (!param) {
        clearQuickFilters?.()
      }
    },
    identifier: 'expensesList.statusFilter',
    path: 'status',
    title: i18n.t('expenses_v2.list.header.status'),
    default: true,
  }
}

export default statusFilter
